import axiosInstance from './axiosInstance';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TenantOption {
  tenant_id: number;
  tenant_name: string;
}

export interface AuthResponse {
  // Normal login (1 tenant)
  accessToken?: string;
  refreshToken?: string;
  user?: {
    id: string;
    email: string;
    name?: string;
    group_id?: string | number | null;
    permissions?: string[];
  };
  // Multi-tenant: user punya lebih dari 1 tenant
  requireTenantSelect?: boolean;
  tempToken?: string;
  tenants?: TenantOption[];
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  selectTenant: async (tempToken: string, tenant_id: number): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>('/auth/select-tenant', {
      tempToken,
      tenant_id,
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await axiosInstance.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>('/auth/refresh', {
      refreshToken,
    });
    return response.data;
  },

  verifyToken: async (token: string): Promise<{valid: boolean}> => {
    try {
      const response = await axiosInstance.post<{valid: boolean}>('/auth/verify', { token });
      return response.data;
    } catch {
      return {valid: false};
    }
  },
};
